import { Dahsboardlayout } from '@/components/layouts/dashboard';
import { Outlet, useLocation } from '@modern-js/runtime/router';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import "./index.css"

export default function Layout() {
  const location = useLocation()
  return (
    location.pathname.includes("/auth") ?
    <div>
      <Outlet />
    </div> :
    <Dahsboardlayout>
      <Outlet />
    </Dahsboardlayout>
  );
}
